import React from 'react';
import { Box, IconButton, TextField, styled } from '@mui/material';
import { Close } from '@mui/icons-material';
import theme from '../themes/theme';
import CustomValidationText from './CustomValidationText';


const CustomTextField = styled(TextField)(({ theme }) => ({
  '& .MuiFilledInput-root': {
    backgroundColor: '#FFFFFF',
    border: `1px solid #E4E7EC`,
    borderRadius: '10px',
    padding: '0px 0px 0px',
    '&:hover': {
      backgroundColor: '#FFFFFF',
    },
    '&.Mui-focused': {
      backgroundColor: '#FFFFFF',
      borderColor: '#101828',
    },
    '& .MuiFilledInput-input': {
      padding: '15px 16px',
      height: 'auto',
      boxSizing: 'border-box',
    },
  },

  '& .MuiInputBase-input::placeholder': {
    color: theme.palette.customColors.g100,
    opacity: 1,
  },
  // Chrome/Safari force their own autofill background via a UA style that only an
  // inset shadow can cover; the long transition keeps it from flashing back in.
  '& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus, & input:-webkit-autofill:active': {
    WebkitBoxShadow: '0 0 0 100px #FFFFFF inset',
    boxShadow: '0 0 0 100px #FFFFFF inset',
    WebkitTextFillColor: theme.palette.text.primary,
    caretColor: theme.palette.text.primary,
    borderRadius: '10px',
    transition: 'background-color 100000s ease-in-out 0s',
  },
}));



const CustomInputField = ({ label, placeholder, multiline = false ,minRows = 1 , type ='text', startAdornment, endAdornment, fullWidth = true,sx, value, labelStyle = {},hasError = false, errorMessage="" , onClear, ...props  }) => {
  // Search fields pass onClear to get a cross inside the field that clears it,
  // so no separate reset button is needed alongside the input.
  const showClearIcon = typeof onClear === 'function' && String(value ?? '').length > 0;
  return (
    <Box sx={{width: `${fullWidth ? "100%" :  sx.width}`}}>
      {label != undefined && <Box component="label" sx={{ color: theme.palette.customColors.g500, marginBottom: '8px', display: 'block',fontSize:"0.875rem", ...labelStyle }}>
        {label}
      </Box>}
      <CustomTextField
        variant="filled"
        placeholder={placeholder}
        multiline={multiline}
        minRows={minRows}
        value={value}
        fullWidth
        sx={{...sx}}
        InputProps={{
          disableUnderline: true,
          startAdornment: startAdornment,
          endAdornment: showClearIcon ? (
            <>
              <IconButton
                aria-label="clear"
                size="small"
                onClick={onClear}
                sx={{ marginRight: '0.25rem' }}
              >
                <Close sx={{ width: 18, height: 18 }} />
              </IconButton>
              {endAdornment}
            </>
          ) : endAdornment
        }}
        type={type}
        {...props}
      />
      {hasError && <CustomValidationText value={errorMessage} />}
    </Box>
  );
};
export default CustomInputField
